import { useMutation, useQueryClient } from '@tanstack/react-query'
import { deleteMeetingAttachment, updateMeeting } from '../api/meetingApi'
import { uploadMinutesAttachments } from '../../minutes/api/minutesApi'
import type { MeetingUpdateRequest } from '../types'

export interface UpdateMeetingVars {
  id: number
  body: MeetingUpdateRequest
  /** Kaldırılacak mevcut ek id'leri (soft-delete). */
  removeAttachmentIds: number[]
  /** Yeni yüklenecek dosyalar. */
  newFiles: File[]
}

/**
 * Toplantı düzenleme mutasyonu (044). Sıra: (1) temel bilgiler + katılımcılar (PUT — optimistic lock;
 * bayat modDate 409'da burada durur, ekler dokunulmaz) → (2) işaretli ekleri kaldır → (3) yeni dosyaları
 * yükle. Başarıda detay + grup listeleri tazelenir. Hata global onError ile toast'lanır (409 = bayat sürüm);
 * form bileşeni açık kaldığından girilen veri korunur.
 */
export function useUpdateMeeting() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: async ({ id, body, removeAttachmentIds, newFiles }: UpdateMeetingVars) => {
      await updateMeeting(id, body)
      for (const attachmentId of removeAttachmentIds) {
        await deleteMeetingAttachment(id, attachmentId)
      }
      if (newFiles.length > 0) {
        await uploadMinutesAttachments(id, newFiles)
      }
    },
    onSuccess: (_data, vars) => {
      qc.invalidateQueries({ queryKey: ['meeting-detail', vars.id] })
      qc.invalidateQueries({ queryKey: ['meeting-groups'] })
    },
  })
}
